import React from 'react';
import { Button as AntdButton } from 'antd';
import clsx from 'clsx';

const Button = (props) => {
    const {
        size = 'small',
        type = 'primary',
        className,
        onClick,
        disabled,
        icon,
        children
    } = props;

    return (
        <AntdButton
            size={size}
            type={type}
            className={clsx('px-4', className)}
            onClick={onClick}
            disabled={disabled}
            icon={icon}
        >
            {children}
        </AntdButton>
    );
};

export default Button;
